import PersonComponent from "./PersonComponent";


const AboutUsComponent = () => (
    <section id="aboutus" className="py-12 relative">
        <div className="text-center mb-8">
            <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                O nas
            </h2>
            <p className="mt-4 text-xl text-gray-400">Kim jesteśmy i co robimy?</p>
        </div>
        {/*Jakub*/}
        <PersonComponent image_path={"jakub.jpg"} fullname={"Jakub Krawczyk"} specjalnosci={["Modelowanie 3D", "Inżynier programista", "Specjalista QA"]} discord={"jakubjkrawczyk"} linkedin_url={"https://www.linkedin.com/in/jakub-krawczyk-81b4441b2/"} site_url={"https://jakubkrawczyk.com"} cite={"\"Nie ma rzeczy nie możliwych, ogranicza nas tylko czas, więc trzeba wybierać mądrze\""} />
        {/*Łukasz*/}
        <PersonComponent image_path={"łukasz.jpg"} fullname={"Łukasz Mastalerz"} specjalnosci={["Inżynier programista", "Specjalista QA"]} discord={"lakasabasz"} linkedin_url={"https://www.linkedin.com/in/%C5%82ukasz-mastalerz-23341a169/"} site_url={"https://lukaszm.info.pl"} cite={"\"Starożytni czarodzieje nazywali używanie tego języka zaklęciami. Ale jeśli to słowo obraża twoją współczesną wrażliwość, możesz nazwać je programem, kodem źródłowym, który kształtuje rzeczywistość.\""} />
        {/*Grzegorz*/}
        <PersonComponent image_path={"grzegorz.jpg"} fullname={"Grzegorz Kramarz"} specjalnosci={["Projektant systemów elektronicznych", "Technik elektryk"]} discord={"tanatos2319"} linkedin_url={null} site_url={null} cite={"\"Człowiek jest tylko produktem swoich myśli; tym, co myśli, tym się staje.\" ~ Mahatma Gandhi"} />
    </section>
)

export default AboutUsComponent
